export function handleResponse(response) {
    return response.text().then(text => {
        if (response.ok) {
            return { ok: response.ok, data: JSON.parse(text)}
        }
        else{
            return { ok: response.ok, error: text}
        }
    });
}